import XcHorizontalRule from "@electricMotorShop/Widgets/Basic/XcHorizontalRule";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { ClickablePresentationProps } from "@insite/mobius/Clickable";
import { IconMemo, IconPresentationProps } from "@insite/mobius/Icon";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";

interface OwnProps {
    panelTitle: string;
    hasChildren: boolean;
    panelUrl?: string;
    showUserIcon?: boolean;
}

type XcPanelStandardProps = OwnProps;

interface XcPanelStandardStyles {
    panelRow?: InjectableCss;
    contentWrapper?: InjectableCss;
    innerContentWrapper?: InjectableCss;
    userIcon?: IconPresentationProps;
    title?: TypographyPresentationProps;
    button?: ClickablePresentationProps;
    buttonText?: TypographyPresentationProps;
    rightIcon?: IconPresentationProps;
}

const xcPanelStandardStyles: XcPanelStandardStyles = {
    contentWrapper: {
        css: css`
            width: 100%;
            display: flex;
            flex-direction: column;
        `,
    },
    innerContentWrapper: {
        css: css`
            width: 100%;
            display: flex;
            flex-direction: row;
            align-items: center;
            padding: 10px 10px 10px 20px;
        `,
    },
    userIcon: {
        src: "User",
        color: "common.backgroundContrast",
        size: 28,
        css: css`
            margin-top: -2px;
            margin-right: 10px;
            width: 24px;
            display: inline-block;
            text-align: center;
            vertical-align: middle;
        `,
    },
    title: {
        css: css`
            margin-right: 8px;
            width: 100%;
        `,
    },
    rightIcon: {
        color: "common.accent",
        src: "ChevronRight",
        size: 22,
    },
};

const styles = xcPanelStandardStyles;

const XcPanelStandard = (props: XcPanelStandardProps) => {
    const { hasChildren, showUserIcon, panelTitle } = props;

    return (
        <StyledWrapper {...styles.contentWrapper}>
            <StyledWrapper {...styles.innerContentWrapper}>
                {showUserIcon && (
                    <IconMemo {...styles.userIcon} />
                )}
                <Typography
                    className="main-navigation-row-text"
                    {...styles.title}
                >
                    {panelTitle}
                </Typography>
                {hasChildren && (
                    <IconMemo {...styles.rightIcon} />
                )}
            </StyledWrapper>
            <XcHorizontalRule />
        </StyledWrapper>
    )
}

export default XcPanelStandard;
